import React, { useEffect, useState } from 'react';
import '../assets/css/material-dashboard.css'
import HomeLf from './HomeLf';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';

function EditarPendencia(params) {

  const navigate = useNavigate();


  const [current, setCurrent] = useState('');
  const [dataA, setDataA] = useState([]);
  const [dataB, setDataB] = useState([]);
  const [filtrados, setFiltrados] = useState([]);
  const [filtradosB, setFiltradosB] = useState([]);
  const [nomeOrdem, setNomeOrdem] = useState('');
  const [ordemDisciplina, setOrdemDisciplina] = useState([]);
  const [ordemPrioridade, setOrdemPrioridade] = useState('urgente');

var count01 = 0;




const [mapeA, setMapeA] = useState([1]);
const [countMp, setCountMp] = useState(1);






const queryParameters = new URLSearchParams(window.location.search)
const parametroId = queryParameters.get("prjid")
const parametroId2 = queryParameters.get("ordem");


async function master(params) {

      

    var objMaster = [];
    var objMaster2 = [];
  
   // setProjetoId(parametroId);
  
  
    onAuthStateChanged(firebaseAuth, async (currentUser) => {
      if (currentUser) {
        var usuarioLogado = currentUser.email;
        setCurrent(usuarioLogado);
      };
    });
  
  
  
  
  
  
  
          await getDocs(collection(db, "projetos"))
              .then((querySnapshot)=>{               
                  const newData = querySnapshot.docs
  
                      .map((doc) => ({...doc.data(), id:doc.id }));
                      for (let i = 0; i < newData.length; i++) {
          
                     
                             objMaster2.push(newData[i]);
                        
                      }
                 
                      var contas = [];
                
                        var arraya = [...Object.values(objMaster2)];
              
                      var criados = [];
  
                 
                   
                      var emailatual = parametroId;
                      for (let i = 0; i < arraya.length; i++) {
                      
                          
                     if(arraya[i].idProjeto == emailatual){
                        criados.push(arraya[i]);
                     }
  
                        }
  
                        console.log('PAULAAA ',parametroId2);
                      console.log('criados', criados[0].ordens[parametroId2]);
                      setDataA(criados[0].ordens[parametroId2]);
                      setNomeOrdem(criados[0].ordens[parametroId2].nome);
                      setDataB(criados[0].ordens[parametroId2].disciplinas);
                 
                      setTimeout(() => {
                        document.querySelector('.prioridad').value = criados[0].ordens[parametroId2].prioridade;
                      }, 1000);

              })
          
  
  
  
  }


async function editar(params) {
  navigate(`/editar?projeto=${params}`);
}





async function dell(params) {


  await updateDoc(doc(db, 'clientes', `${firebaseAuth.currentUser.email}:projetos`), {
    [params]: {
        nomeDoProjeto: 'nd',
      

    }
  
  });
  navigate(0);
}




function enviarPost01() {


  var seletoresM = [];
  for (let index = 0; index < document.querySelectorAll('.seletores').length; index++) {
    seletoresM.push(document.querySelectorAll('.seletores')[index].value);
  }


  fetch('https://apilumera.shop/api/criarOrdem', {
    method: 'POST',
    body: JSON.stringify({
      email: firebaseAuth.currentUser.email,
      parametroId: parametroId,
      nomeOrdem: nomeOrdem,
      ordemDisciplina: seletoresM,
      ordemPrioridade: ordemPrioridade
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {
       navigate(-1);
     })
     .catch((err) => {
       navigate(-1);
     });
}






useEffect(()=> {
  master();
},[])







var trad = [];

function mapear() {
            
  setCountMp(countMp + 1);

  for (let i = 0; i < countMp; i++) {
      trad.push(i);
      
  }
  trad.push(countMp);
  console.log(trad);
  setMapeA(trad);
}











    return (
        <div>


<HomeLf/>



<aside style={{top: '105px', overflow: 'hidden'}} class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3   bg-gradient-dark" id="sidenav-main">
    <div class="sidenav-header">
      <i class="fas fa-times p-3 cursor-pointer text-white opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav"></i>
      <a class="navbar-brand m-0" target="_blank">

        <span class="ms-1 font-weight-bold text-white">Dashboard</span>
      </a>
    </div>
    <hr class="horizontal light mt-0 mb-2"/>
    <div class="collapse navbar-collapse  w-auto " id="sidenav-collapse-main">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link text-white active " >
            <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
              <i class="material-icons opacity-10">dashboard</i>
            </div>
            <span class="nav-link-text ms-1">Dashboard</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-white "
             onClick={()=> navigate('/adicionar')}
          >
            <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
              <i class="material-icons opacity-10">table_view</i>
            </div>
            <span class="nav-link-text ms-1"
           
            >Adicionar Projeto</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-white "
                onClick={()=> navigate('/colaborador')}
          >
            <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
              <i class="material-icons opacity-10">receipt_long</i>
            </div>
            <span class="nav-link-text ms-1">Colaborador</span>
          </a>
        </li>


      

    
      </ul>
    </div>
 
  </aside>
  <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">

    <nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" id="navbarBlur" data-scroll="true">
      <div class="container-fluid py-1 px-3">
     
    
      </div>
    </nav>

    <div class="container-fluid py-4">

      
      <div class="row mb-4"  style={{marginTop: '20px'}}>
        <div class="col-lg-12 col-md-6 mb-md-0 mb-4">
          <div class="card">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-lg-6 col-7">
                  <h6>Editar pendências</h6>
                  <p class="text-sm mb-0">
                 
            
                  </p>
                </div>
                <div class="col-lg-6 col-5 my-auto text-end">
               
                </div>
              </div>
            </div>
            <div class="card-body px-0 pb-2">
              <div class="table-responsive">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nome</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Disciplina</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Prioridade</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Manager</th>
                    </tr>
                  </thead>
                  <tbody>
              
      

<>

 <> 

<tr>
<td>
  <div class="d-flex px-2 py-1">
    <div>

    </div>
    <div class="d-flex flex-column justify-content-center">
      <h6 class="mb-0 text-sm" style={{ padding: '0px 10px', border: 'solid black 1px'}}><input 
 
      value={nomeOrdem}
      placeholder='Nome'/> </h6>
    </div>
  </div>
</td>
<td>
  <div class="avatar-group mt-2">






  <div style={{ paddingLeft: '10px', maxWidth: '290px', paddingRight: '10px', display: 'flex', flexFlow: 'row wrap', alignItems: 'center', borderRadius: '10px', border: '2px solid #777', margin: '5px' }}> 

<>
                                {dataB.map((data, index) => {

return <> 




                       
<select
      onChange={(e)=> setOrdemDisciplina(e.target.value)}
      style={{margin: '5px'}}
      className='seletores'
>

<>


  <> 
                           {dataB.map((data, index) => {

                            return <> 
                            
                            <option value={data}>{data}</option>
                            </>
                            })}</>

 
     
                  </>
</select>
                       
                       
              

</>
})}
                  </>

      


</div> 







  </div>
</td>
<td class="align-middle text-center text-sm">
  <span class="text-xs font-weight-bold">
    
  <select
  style={{fontSize: '14px'}}
  onChange={(e) => {setOrdemPrioridade(e.target.value);}}
    className="prioridad"
  >
  <option value="baixa">Baixa</option>
  <option value="media">Média</option>
  <option value="alta">Alta</option>


  </select>
    
     </span>
</td>
<td class="align-middle  text-center">
  <div class="progress-wrapper mx-auto">
    <a style={{ cursor: 'pointer', border: '2px black solid', borderRadius: '10px', padding: '10px'}}
    onClick={()=> enviarPost01()}
    > Salvar </a>
  
  </div>
</td>
</tr>






</>

                    </>







                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
   
      </div>
      <footer class="footer py-4  ">
        <div class="container-fluid">
          <div class="row align-items-center justify-content-lg-between">
            <div class="col-lg-6 mb-lg-0 mb-4">
  
            </div>
     
          </div>
        </div>
      </footer>
    </div>
  </main>






        </div>
    )
}
export default EditarPendencia;